<template>
<main class="inquiry">
  <h1 class="heading-common is-btn-back"><a class="btn-back" @click="back"></a> {{ $t('inquiry.title') }}</h1>

  <!-- Container -->
  <section class="container inquiry-container" v-show="isLoading">
    <div class="row">
      <template v-if="inquiryList && inquiryList.length">
        <ul class="inquiry-list">
          <li v-for="(inquiry, inquiry_idx) in inquiryList" :key="inquiry_idx" :class="(inquiry.post_type == '1') ?'in':'out'">
            <div class="box inquiry-box" :class="inquiry.post_type_name">
              <div class="title-head"><template v-if="inquiry.post_type != '1'">({{ inquiry.post_type_name }}) </template>{{ inquiry.post_date }} <a class="button-edit" v-if="inquiry.post_type == '1'" @click="editMessage(inquiry.inquiry_message_id)"><span class="material-icons">edit</span></a></div>
              <div class="detail" v-html="inquiry.message"></div>
            </div>
          </li>
        </ul>
      </template>
      <template v-else>
        <div class="box" v-show="!isLoading">{{ $t('notice.no-message') }}</div>
      </template>
    </div>
    <div class="space-20"></div>
  </section>
  <footer class="content-bottom">
    <button type="button" class="button button-primary inquiry" @click.prevent="openMakeMessage">{{ $t('inquiry.make_inquiry') }}</button>
  </footer>
</main>
</template>

<script>
  import {api} from "../../config";
  import { mapActions, mapGetters, mapState } from 'vuex'

  export default {
    data () {
      return {
        loading: false
      }
    },
    computed: {
      ...mapState({
        user: state => state.auth
      }),
      isLoading () {
        return this.loading
      },
      inquiryList() {
         return this.$store.getters.inquirylist
      },
      isInquiryMessage() {
        return (this.$route.name == 'inquiry.message')
      },
    },
    
    created() {
      this.loading = false
    },

    mounted() {
      
      const self = this
      self.loading = false
      
      self.$store.dispatch('showLoading', true)
      
      self.$store.dispatch('clearInquiryList');
      
      if(!self.$store.getters.inquirylist || self.$store.getters.inquirylist.length == 0) {
        self.$store.dispatch('getInquiryList')
          .then(() => {
            self.loading = true
            self.$store.dispatch('showLoading', false)
            if(self.$store.getters.inquirylist.length == 0) {
              self.openMakeMessage()
            } else {
              let lastMessage = self.$store.getters.inquirylist[self.$store.getters.inquirylist.length - 1]
              // mark as read
              axios.post(api.newsMarkAsRead, { type: 'inquiry', inquiry_id: lastMessage.inquiry_id })
            }
          })
      } else {
        self.loading = true
        self.$store.dispatch('showLoading', false)
        
        let lastMessage = self.$store.getters.inquirylist[self.$store.getters.inquirylist.length - 1]
        // mark as read
        axios.post(api.newsMarkAsRead, { type: 'inquiry', inquiry_id: lastMessage.inquiry_id })

      }
    },
    methods: {
      editMessage(inquiry_message_id) {
        this.$router.push({name: 'inquiry.message', params: { inquiry_message_id: inquiry_message_id }});
      },
      openMakeMessage(data) {
        this.$router.push({name: 'inquiry.message'});
      },
      back() {
        this.$router.push({name: 'lesson'})
      }
    }

  }
</script>
